export default {
    base: {}
};
